import Http from 'axios'
import {
    VERSIONED_API_URL,
} from '../../config/config'

function initialState() {
    return {
        desks: [],
        office_desks: []
    }
}

const getters = {
    desks: state => state.desks,
    loading: state => state.loading,
    office_desks: state => state.office_desks
};

const actions = {

    fetchData({commit}) {
        Http.get(`${VERSIONED_API_URL}/airport-terminal/desks`).then((response) => {
            commit('setDesks', response.data.data)
        })
    },
    async fetchDeskByOffice({commit}, office) {
        try {
            const response = await Http.get(`${VERSIONED_API_URL}/airport-terminal/desks`, {
                params: {
                    office
                }
            });
            commit('setOfficeDesk', response.data.data);
        } catch (e) {

            throw e;
        }
    },

    resetState({commit}) {
        commit('resetState')
    }
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    setDesks(state, item) {
        state.desks = item;
    },
    setOfficeDesk(state, item) {
        state.office_desks = item;
    }
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
